import { ArrowLeft, Loader2, Settings2 } from 'lucide-react';

import ActionButton from '../../../../../components/Buttons/ActionButton';
import SelectField from '../../../../../components/Forms/Input/SelectField';
import { IBranchDropdown } from '../../../../../types/branches/branchInterfaces';

interface Props {
  branches: IBranchDropdown[];
  branchId: number | '';
  loadingBranches: boolean;
  branchError: string;
  canPickBranch: boolean;
  onBranchChange: (branchId: number) => void;
  onBack: () => void;
}

const MenuConfigurationHeader = ({
  branches,
  branchId,
  loadingBranches,
  branchError,
  canPickBranch,
  onBranchChange,
  onBack,
}: Props) => (
  <header className="border-b border-stroke px-5 py-5 dark:border-strokedark sm:px-7">
    <div className="flex flex-col gap-5 xl:flex-row xl:items-end xl:justify-between">
      <div className="flex items-start gap-3">
        <span className="rounded-xl border border-primary/15 bg-primary/10 p-2.5 text-primary dark:border-primary/25 dark:bg-primary/15">
          <Settings2 className="h-5 w-5" />
        </span>
        <div>
          <h1 className="text-xl font-semibold text-black dark:text-white">
            Configuración del menú
          </h1>
          <p className="mt-1 max-w-2xl text-sm text-bodydark2 dark:text-bodydark">
            Configure opciones adicionales, combos y modificadores disponibles
            para cada plato.
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-3 sm:flex-row sm:items-end">
        <ActionButton
          label="Volver al menú"
          icon={<ArrowLeft className="h-4 w-4" />}
          variant="secondary"
          size="md"
          fullWidth={false}
          onClick={onBack}
          className="h-[50px] whitespace-nowrap px-5"
        />

        {canPickBranch && (
          <div className="w-full sm:w-80">
            {loadingBranches ? (
              <div className="flex h-[74px] items-center justify-center gap-2 text-sm text-bodydark2">
                <Loader2 className="h-4 w-4 animate-spin text-primary" />
                Cargando sucursales...
              </div>
            ) : (
              <SelectField
                label="Sucursal"
                name="catalogBranch"
                value={branchId}
                iconKey="building"
                withMargin={false}
                placeholder="Seleccione una sucursal"
                options={branches.map((branch) => ({
                  value: branch.id,
                  label: branch.name,
                }))}
                onChange={(event) =>
                  onBranchChange(Number(event.target.value))
                }
              />
            )}
          </div>
        )}
      </div>
    </div>

    {branchError && (
      <p className="mt-3 text-sm font-medium text-danger">{branchError}</p>
    )}
  </header>
);

export default MenuConfigurationHeader;
